import React from 'react';
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { getAuth } from './store/actions/auth';
import './App.css';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { LoomisColors } from './lib/LoomisColors';
import {HashRouter, Route, Switch} from 'react-router-dom';

// Pages
import StartPage from './pages/StartPage';

import MainPage from './pages/MainPage';
import LoginPage from './pages/LoginPage';
import Logout from './components/logout/Logout';
import ForgotPage from './pages/ForgotPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

import CustomersPage from './pages/CustomersPage';
import CustomerPage from './pages/CustomerPage';

import ServersPage from './pages/ServersPage';
import ServerPage from './pages/ServerPage';

import CountriesPage from './pages/CountriesPage';

import UsersPage from './pages/UsersPage';
import UserPage from './pages/UserPage';

import ErrorPage from './pages/ErrorPage';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: LoomisColors.lightBlue,
    }
});

const App = () => (
    <HashRouter>
        <MuiThemeProvider muiTheme={muiTheme} >
            <Switch>
                <Route exact path="/" component={MainPage} />
                <Route path="/login" component={LoginPage} />
                <Route path="/logout" component={Logout}/>
                <Route path="/forgot" component={ForgotPage} />
                <Route path="/reset/:token" component={ResetPasswordPage} />

                <Route path="/start" component={StartPage} />


                <Route path="/customers/:customerId" component={CustomerPage} />
                <Route path="/customers" component={CustomersPage} />

                <Route path="/servers/:serverId" component={ServerPage} />
                <Route path="/servers" component={ServersPage} />

                <Route path="/countries" component={CountriesPage} />

                <Route path="/users/:userId" component={UserPage} />
                <Route path="/users" component={UsersPage} />

                <Route path="/error" component={ErrorPage} />

                <Route component={MainPage} />
            </Switch>
        </MuiThemeProvider>
    </HashRouter>
);

const mapDispatchToProps = (dispatch) => {
    return {
        getAuth: () => dispatch(getAuth())
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.getAuth();
    }
};

export default compose(
    connect(null, mapDispatchToProps),
    lifecycle(lifecycleValue)
)(App);




// WEBPACK FOOTER //
// ./src/App.js